import React from "react";
import FAQItem from "../components/FAQItem";

export default function FAQ() {
  const faqs = [
    {
      q: "How does pickup & delivery work?",
      a: "After booking, our driver will collect your clothes at the scheduled time and return them cleaned based on selected service."
    },
    {
      q: "What is your turnaround time?",
      a: "Standard service takes 48–72 hours. Express options are available depending on schedule."
    },
    {
      q: "Where do you serve?",
      a: "We serve Sunriver, OR and surrounding regions. Additional areas may be added soon."
    },
    {
      q: "What payment methods do you accept?",
      a: "We accept card payments, cash, and online invoicing at delivery."
    },
    {
      q: "What happens if an item gets damaged?",
      a: "We handle items with utmost care. Any damage due to our service will be reviewed and compensated per our Terms."
    }
  ];

  return (
    <section className="page-container">
      <h2>Frequently Asked Questions</h2>
      {faqs.map((f, i) => <FAQItem key={i} {...f} />)}
    </section>
  );
}
